export enum VehicleDropdownKeys {
  SEARCH_KEY_ENTER = 'Enter',
  SEARCH_KEY_TAB = 'Tab',
  SEARCH_KEYCODE = 40,
}
